import { Location } from '@angular/common';
import {
  AfterViewChecked,
  Component,
  computed,
  effect,
  inject,
  OnInit,
  ViewChild,
} from '@angular/core';
import { MatSidenav } from '@angular/material/sidenav';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { filter, switchMap, take } from 'rxjs';
import { OriginsEnum } from './configuration/enums/origins.enum';
import { SplitIoService } from './configuration/services/split-io.service';
import { TooltipService } from './configuration/services/tooltip.service';
import { DeviceInfoService } from './services/device-info.service';
import { APP_DRAWER_CONFIG, AppDrawerId, AppDrawerService } from './services/app-drawer.service';
import { OfferService } from './services/offers.service';
import { selectConfigOrigin } from './store/states/config/config.selectors';
import { selectSessionClient } from './store/states/session/session.selectors';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
  standalone: false,
})
export class AppComponent implements OnInit, AfterViewChecked {
  @ViewChild('userDrawer') userDrawer!: MatSidenav;
  @ViewChild('installmentsDrawer') installmentsDrawer!: MatSidenav;
  title = 'flexpag-whitelabel-checkout';
  private deviceInfo = inject(DeviceInfoService);
  private store = inject(Store);
  private OfferService = inject(OfferService);
  private appDrawerService = inject(AppDrawerService);
  private splitIoService = inject(SplitIoService);
  private readonly origin = this.store.selectSignal(selectConfigOrigin);
  private readonly isOriginSerasa = computed(
    () => this.origin() === OriginsEnum.MINHAS_CONTAS || this.origin() === OriginsEnum.LNO
  );

  constructor(
    private tooltipService: TooltipService,
    private router: Router,
    private location: Location
  ) {
    effect(() => this.syncDrawers(this.appDrawerService.activeDrawer()));
    this.store
      .select(selectSessionClient)
      .pipe(
        filter(() => !this.isOriginSerasa()),
        filter((client) => !!(client.ni || client.identityNumber)),
        take(1),
        switchMap((client) => this.OfferService.getFeatures(client.ni ?? client.identityNumber))
      )
      .subscribe();

    this.splitIoService.setDefaultFeaturesFlags();
  }

  backdropClick() {
    this.appDrawerService.close();
  }

  private syncDrawers(active: AppDrawerId | null): void {
    const registry: Record<AppDrawerId, MatSidenav | undefined> = {
      userMenu: this.userDrawer,
      installments: this.installmentsDrawer,
    };

    (Object.keys(APP_DRAWER_CONFIG) as AppDrawerId[]).forEach((id) => {
      const drawer = registry[id];
      if (!drawer) return;

      const action = active === id ? 'open' : 'close';
      drawer[action]();
    });
  }

  ngOnInit(): void {
    console.log('version: 8.7.4');
    this.clearSessionStorage();
    this.deviceInfo.getIPAddress().subscribe();
  }

  ngAfterViewChecked(): void {
    this.tooltipService.initializeTooltips();
  }

  /**
   * Limpa dados do sessionStorage do Minha Carteira na Inicialização da aplicação
   */
  clearSessionStorage() {
    const keysToRemove = ['UF', 'debt_source', 'form', 'principalType'];
    keysToRemove.forEach((key) => sessionStorage.removeItem(key));
  }
}
